// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconfont{font-size:inherit}.t-close:before{content:\"✕\"}.t-like:before{content:\"♥\"}.t-right:before{content:\"❯\"}.t-left:before{content:\"❮\"}.t-keyboard:before{content:\"‧‧‧‧\"}.t-exclamation:before{content:\"!\"}", ""]);
// Exports
module.exports = exports;
